import MuiAlert, {AlertProps} from '@mui/material/Alert'

export const Alert = (props: AlertProps) => {
    return <MuiAlert {...props} />
}